import { basicCacheKeys } from '@/utils/cacheConfig'
import { getSpecificBasicData } from '@/utils/basicDataCache'
import { loadDateAutoInitRule } from '@/api/dateAutoInitRule'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import { SeaImportJob } from '@/class/model/booking/SeaImportJob'

export class DateAutoInitRuleManage {
  /**
   * instance
   */
  static instance
  /**
   * constructor
   */
  constructor() {
    this._dateAutoInitRule = null // 业务日期默认计算规则
    this._baseEntity = null // 业务实体
    this._calculateEntity = null // 需要计算实体
    this._type = null // 业务类型
    this.seaPortList = null
    this.ariPortList = null
    this.regionList = null
  }
  get dateAutoInitRule() {
    if (!this._dateAutoInitRule) {
      this._dateAutoInitRule = []
    }
    return this._dateAutoInitRule
  }
  set dateAutoInitRule(dateAutoInitRule) {
    this._dateAutoInitRule = dateAutoInitRule
  }
  /**
   * singleton
   */
  static getInstance() {
    if (!this.instance) {
      this.instance = new DateAutoInitRuleManage()
    }
    return this.instance
  }
  /**
   * 自定计算业务字段
   */
  async autoCalculateDateRule(baseEntity, calculateEntity, type) {
    if (!baseEntity || !calculateEntity) {
      return
    }
    if (!this._baseEntity || this._type !== type) {
      this._dateAutoInitRule = await loadDateAutoInitRule({ lob: type }).then(res => res.data)
    }
    this._type = type
    this._baseEntity = baseEntity
    this._calculateEntity = calculateEntity
    await this.calculateBaseDateField()
  }
  async loadDateAutoInitRuleHandler(data) {
    this._dateAutoInitRule = data
    await this.calculateBaseDateField()
  }
  async calculateBaseDateField() {
    if (this.dateAutoInitRule.length > 0) {
      this.seaPortList = await getSpecificBasicData(basicCacheKeys.basic_data_Seaport)
      this.ariPortList = await getSpecificBasicData(basicCacheKeys.basic_data_Airport)
      this.regionList = await getSpecificBasicData(basicCacheKeys.basic_data_Region)
      for (const rule of this.dateAutoInitRule) {
        if (this.getValIgnoreCase(this._baseEntity, rule.baseDateField) && this._calculateEntity.hasOwnProperty(rule.dateEntity) &&
          !this._calculateEntity[rule.dateEntity] && this.checkPort(rule)) {
          this._calculateEntity[rule.dateEntity] = this.getDefaultValue(rule)
        }
      }
    }
  }
  getValIgnoreCase(obj, key) {
    key = key.toLowerCase()
    for (const name in obj) {
      if (name.toLowerCase() === key) {
        return obj[name]
      }
    }
    return undefined
  }
  getDefaultValue(rule) {
    const calcRule = rule.calcRule.split(',')
    if (calcRule && calcRule.length > 1) {
      const operator = calcRule[0]
      const value = Number(calcRule[1])
      const date = new Date(this.getValIgnoreCase(this._baseEntity, rule.baseDateField))
      if (operator === '-') {
        return new Date(date.getFullYear(), date.getMonth(), date.getDate() - value, date.getHours(), date.getMinutes(), date.getSeconds())
      } else if (operator === '+') {
        return new Date(date.getFullYear(), date.getMonth(), date.getDate() + value, date.getHours(), date.getMinutes(), date.getSeconds())
      }
    }
    return null
  }
  /**
   * 港口检查
   */
  checkPort(rule) {
    const region = this.getRegion()
    if (region) {
      const re = this.regionList.filter(p => p.code === region)[0]
      if (re && re.code === rule.dataFilter) {
        return true
      }
    }
    return false
  }
  getRegion() {
    if (this._baseEntity) {
      if (this._baseEntity instanceof SeaExportJob || this._baseEntity instanceof SeaImportJob) {
        const seaPort = this.seaPortList.filter(p => p.code === this._baseEntity.dischargingPortCode)[0]
        return seaPort ? seaPort.region : ''
      } else {
        const airPort = this.airPortList.filter(p => p.code === this._baseEntity.dischargingPortCode)[0]
        return airPort ? airPort.region : ''
      }
    }
    return ''
  }
}
